import React, { Component } from "react";

class TerminosYCondicionesScreen extends Component {
  state = {};
  render() {
    return (
      <div className="site-section">
        <div className="container col-md-12">
          <div className="col-md-12">
            <h4>Términos y Condiciones</h4>
          </div>
          <div className="col-md-12">
            <h4>Información Legal</h4>
            <p>
              Hubtalent Consultoría Estratégica y Soluciones Informáticas S.L.,
              en adelante HUBTALENT, con domicilio social en Madrid, España, en
              Calle de Bravo Murillo 377, 3C. 28020 Madrid; provista de CIF
              B-86562246, número de teléfono 91 161 03 00 y correo electrónico
              lopd@hubtalent.es / admin@hubtalent.es / rrhh@hubtalent.es, e
              inscrita en el Registro Mercantil de Madrid, Tomo 30.320, Folio
              141, Hoja M-545762 (en adelante Hubtalent) es la titular y
              propietaria de los Sitio/s Web indicados en el dominio
              www.hubtalent.es, en adelante WEB.
            </p>

            <p>
              HUBTALENT se reserva la posibilidad de modificar sin previo aviso,
              el diseño, presentación y/o configuración de estos WEB, así como
              algunos o todos los servicios, y añadir servicios nuevos.
            </p>
            <p>
              HUBTALENT entiende por CANDIDATO, en adelante USUARIO, los
              USUARIOS personas físicas que buscan empleo o servicios
              relacionados con el mundo laboral, la orientación profesional o la
              formación, que utilicen los servicios de HUBTALENT y accedan a la
              WEB de los que es titular HUBTALENT
            </p>
            <p>
              HUBTALENT entiende por Empresa y/o Cliente, en adelante CLIENTE,
              aquellas entidades que utilicen los servicios de HUBTALENT y
              accedan la WEB de los que es titular HUBTALENT.
            </p>

            <h4>Objeto</h4>
            <p>
              Las presentes Condiciones Legales regulan el acceso y el uso, por
              parte del USUARIO y/o CLIENTE, de los servicios de la WEB. La
              finalidad de HUBTALENT es la de proporcionar información sobre los
              servicios que ofrece HUBTALENT en materia de selección de personal
              a los diferentes USUARIOS y/o CLIENTES, y de proporcionar
              información y ofertas de empleo a los diferentes USUARIOS
              interesados en las mismas, facilitando a los USUARIOS la
              inscripción en las diferentes ofertas de empleo dentro de la WEB y
              el envío de su C.V.
            </p>
            <p>
              El uso de la WEB implica al USUARIO y/o CLIENTE la plena
              aceptación de las disposiciones incluidas en las Condiciones
              Legales en la versión publicada por HUBTALENT en el momento en que
              el USUARIO y/o CLIENTE accede a la WEB.
            </p>
            <p>
              HUBTALENT recomienda leer periódicamente las presentes
              Condiciones.
            </p>
            <p>
              HUBTALENT podrá eliminar de la WEB contenidos sin previo aviso.
            </p>
            <p>
              El USUARIO y/o CLIENTE reconoce que técnicamente no es posible
              lograr una disponibilidad de la WEB al 100%. Sin embargo,
              HUBTALENT se esforzará por mantener disponible la WEB de la forma
              más constante posible. Especialmente por razones de mantenimiento,
              seguridad o capacidad, así como a causa de acontecimientos sobre
              los que no pueda influir HUBTALENT (por ejemplo anomalías de redes
              públicas de comunicación, cortes de electricidad, etc.), pueden
              producirse breves anomalías o la suspensión pasajera de los
              servicios de HUBTALENT.
            </p>
            <h4>Servicios</h4>
            <p>Se enumeran los servicios que HUBTALENT presta al USUARIO:</p>
            <ul>
              <li>
                Visualización en la sección “Empleo” de la WEB de las ofertas de
                empleo que HUBTALENT gestiona en cada momento.
              </li>
              <li>
                Inscripción del USUARIO de forma gratuita a cada una de las
                ofertas.
              </li>
              <li>
                Envío del C.V. del USUARIO a cada una de las ofertas de empleo
                visualizadas en la sección “Empleo” de la WEB.
              </li>
            </ul>
            <p>Se enumeran los servicios que HUBTALENT presta a CLIENTES:</p>
            <ul>
              <li>
                Visualización a nivel informativo de los servicios generales de
                HUBTALENT como especialista en selección de personal.
              </li>
            </ul>
            <h4>Obligaciones del USUARIO y/o CLIENTE</h4>
            <p>
              El USUARIO y/o CLIENTE se compromete a hacer un uso diligente de
              la WEB y de los servicios accesibles desde la misma, con total
              sujeción a la Ley, a las buenas costumbres y a las presentes
              Condiciones Legales y, en su caso, condiciones particulares.
            </p>
            <p>
              HUBTALENT condiciona la utilización de la mayoría de sus servicios
              a la previa aceptación del USUARIO y/o CLIENTE del Tratamiento de
              de Datos Personales conforme a lo establecido en la Ley 15/1999 de
              Protección de Datos y en el Nuevo Reglamento Europeo de Protección
              de Datos.
            </p>
            <p>
              El USUARIO y/o CLIENTE deberá aceptar de forma libre, específica,
              informada e inequívoca, el tratamiento de sus datos personales,
              debiendo para ello aceptar el aviso legal al respecto en cada una
              de las ofertas de empleo a las que desee inscribirse o enviar su
              C.V. Este aviso se mostrará como paso previo y necesario a la
              inscripción en cada una de las ofertas.
            </p>
            <p>
              Toda la información que facilite el USUARIO y/o CLIENTE a través
              de la WEB deberá ser veraz. A estos efectos el USUARIO garantiza
              la autenticidad de todos aquellos daros que comunique como
              consecuencia de la inscripción a las ofertas de empleo publicadas
              en la WEB. Asimismo el USUARIO garantiza que es mayor de 18 años.
            </p>
            <p>
              En todo caso el USUARIO será el único responsable de las
              manifestaciones falsas o inexactas que realice y de los perjuicios
              que cause a HUBTALENT o a terceros por la información que
              facilite.
            </p>
            <p>
              El USUARIO y/o CLIENTE se obligan a respetar las leyes aplicables
              y los derechos de terceros al utilizar los contenidos y servicios
              de la WEB. Asimismo queda prohibida la reproducción, distribución,
              transmisión, adaptación o modificación, por cualquier medio y en
              cualquier forma, de los contenidos de la WEB (textos, diseños,
              gráficos, informaciones, bases de datos, archivos de sonido y/o
              imagen, logos, etc.) y demás elementos de esta WEB, salvo
              autorización previa de sus legítimos titulares o cuando así
              resulte permitido por la ley.
            </p>
            <p>
              De modo ilustrativo y no limitativo, está prohibido: utilizar
              contenidos injuriosos o calumniosos, con independencia de que esos
              contenidos afecten a otros USUARIOS, a otras personas o CLIENTES,
              utilizar contenidos pornográficos o que vulneren las leyes de
              protección de menores, hacer publicidad, ofrecer o distribuir
              productos pornográficos o que vulneren las leyes de protección de
              menores, utilizar contenidos protegidos legalmente (p. ej. por la
              legislación relativa a la propiedad intelectual, a marcas, a
              patentes, a modelos de utilidad o a modelos estéticos) sin tener
              derecho a ello, o hacer publicidad, ofrecer o distribuir bienes o
              servicios protegidos legalmente, así como realizar o fomentar
              acciones contrarias a la libre competencia.
            </p>
            <h4>Responsabilidad</h4>
            <p>
              El USUARIO y/o CLIENTE de la WEB será responsable de los daños y
              perjuicios que HUBTALENT pueda sufrir directa o indirectamente,
              como consecuencia del incumplimiento de cualquiera de las
              obligaciones derivadas establecidas en los presentes Términos y
              Condiciones.
            </p>
            <h4>Límite de Responsabilidad</h4>
            <p>
              En ningún caso HUBTALENT será responsable de algún daño,
              incluyendo sin límite daños, pérdidas o gastos directos,
              indirectos inherentes o consecuentes que surjan en relación con la
              utilización de la WEB, de los enlaces con otras páginas aquí
              recogidas o por cualquier actuación realizada sobre la base de la
              información que en ella se facilita.
            </p>
            <p>
              En todo caso, de ser requerido por orden judicial, HUBTALENT
              colaborará con las autoridades pertinentes en la identificación de
              las personas responsables de aquellos contenidos que puedan violar
              la ley.
            </p>
            <p>
              De igual forma, HUBTALENT elude toda responsabilidad en los
              supuestos de fallo en el rendimiento, error, omisión,
              interrupción, defecto de demora en la operación de transmisión,
              virus informático, fallo del sistema o línea, así como en el
              contenido, exactitud y opiniones expresadas y otras conexiones
              suministradas por estos medios.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default TerminosYCondicionesScreen;
